var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 88,
    viewBox: "0 0 80 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1.75436e-05 30.1139V57.8454C-0.00416577 60.7046 0.739864 63.5143 2.15712 65.9914C3.57437 68.4686 5.61477 70.5256 8.07267 71.9552L31.9273 85.8209C34.3817 87.2485 37.1659 88 40 88C42.8341 88 45.6183 87.2485 48.0727 85.8209L71.9273 71.9552C74.3852 70.5256 76.4256 68.4686 77.8429 65.9914C79.2601 63.5143 80.0042 60.7046 80 57.8454V30.1139C79.9971 27.2617 79.2497 24.4603 77.8328 21.9909C76.4159 19.5216 74.3793 17.471 71.9273 16.0448L48.0727 2.17907C45.6183 0.751537 42.8341 0 40 0C37.1659 0 34.3817 0.751537 31.9273 2.17907L8.07267 16.2481C5.65006 17.6568 3.63231 19.6755 2.21715 22.1062C0.802002 24.5368 0.0379999 27.2962 1.75436e-05 30.1139Z",
    fill: "#FE6E5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 24C28.9504 24 20 33.0316 20 44C20 55.0483 28.9517 64 40 64C50.9684 64 60 55.0496 60 44C60 33.0304 50.9696 24 40 24ZM32.4211 32.2693C37.7076 28.8238 45.0105 29.3203 49.8832 34.1168C54.6797 38.9895 55.1762 46.2924 51.7307 51.5789L32.4211 32.2693ZM28.1907 36.4997C24.7451 41.7863 25.2416 49.0891 30.0381 53.9619C34.9108 58.7584 42.2137 59.2549 47.5003 55.8093L28.1907 36.4997Z",
    fill: "#FE6E5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 24C28.9504 24 20 33.0316 20 44C20 55.0483 28.9517 64 40 64C50.9684 64 60 55.0496 60 44C60 33.0304 50.9696 24 40 24ZM32.4211 32.2693C37.7076 28.8238 45.0105 29.3203 49.8832 34.1168C54.6797 38.9895 55.1762 46.2924 51.7307 51.5789L32.4211 32.2693ZM28.1907 36.4997C24.7451 41.7863 25.2416 49.0891 30.0381 53.9619C34.9108 58.7584 42.2137 59.2549 47.5003 55.8093L28.1907 36.4997Z",
    fill: "#FE6E5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlock);
export default __webpack_public_path__ + "static/media/icon_block.c7da4eeac04f729d179cf7d169b21bf1.svg";
export { ForwardRef as ReactComponent };